import {debug} from "../../lib/utils";
import {DashboardAction} from "./action";
import {DashboardState} from "./app";

export const reducer = (s: DashboardState, a?: DashboardAction): DashboardState => {
	console.log(s, "this is the dashboard state");
	if(!a) {
		return s
	}

	switch (a.type) {
		case "set new visitors checked":
			return {...s, includesNewVisitors: a.to}
		case "set returning visitors checked":
			return {...s, includesReturningVisitors: a.to}
		case "switch tab":
			return {...s, activeTab: a.tab}
		case "set from date":
			return debug({...s, fromDate: a.date})
		case "set to date":
			return {...s, toDate: a.date}
		case "start obtaining dashboard data":
			return {...s, loading: "loading"}
		case "aborted obtaining dashboard data":
			return {...s, loading: "failed"}
		case "finished obtaining dashboard data":
			return {
				...s,
				visits: a.data.visits,
				times: a.data.times,
				sources: a.data.sources,
				loading: "done",
				tabs: {
					'traffic sources': {
						...s.tabs['traffic sources'],
						pagination: Object.assign({}, s.tabs['traffic sources'].pagination, {page: 1}),
						data: a.data.sourcesDetail
					},
					'keywords': {
						...s.tabs['keywords'],
						pagination: Object.assign({}, s.tabs['keywords'].pagination, {page: 1}),
						data: a.data.keywordsDetail
					},
					'content': {
						...s.tabs['content'],
						pagination: Object.assign({}, s.tabs['content'].pagination, {page: 1}),
						data: a.data.contentDetail
					},
					'event detail': {
						...s.tabs['event detail'],
						pagination: Object.assign({}, s.tabs['event detail'].pagination, {page: 1}),
						data: a.data.eventDetail
					},
					'ecommerce': {
						...s.tabs['ecommerce'],
						pagination: Object.assign({}, s.tabs['ecommerce'].pagination, {page: 1}),
						data: a.data.ecommerce
					},
				}
			}
		case "set limit":
			return (() => {
				const tabs = {...s.tabs}
				tabs[a.on].pagination.limit = a.limit

				return {...s, tabs}
			})()
		case "set page":
			return (() => {
				const tabs = {...s.tabs}
				tabs[a.on].pagination.page = a.page

				return {...s, tabs}
			})()
		case "open overview for day by id":
			return {...s, overviewing: a.dayId}
		case "close overview":
			return {...s, overviewing: undefined}
		case "add to keyword cache":
			const keywords = {...s.keywords}
			keywords[a.dayId] = a.result
			return {...s, keywords}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/dashboard/reducer.ts